import { notification, ConfigProvider, NotificationArgsProps } from 'antd';
import { useTheme } from '../../theme/ThemeContext';

// Define the notification props type with optional 'data-test'
export type NotificationProps = NotificationArgsProps & { 'data-test'?: string };

// Notification wrapper with theme support
const useNotification = () => {
    const theme = useTheme();

    // Wrapper for opening notifications with the theme
    const openNotificationWithTheme = (args: NotificationProps) => {
        ConfigProvider.config({
            theme, // Apply the custom theme from context
        });
        notification.open(args); // Call the antd notification function
    };

    return {
        open: (args: NotificationProps) => openNotificationWithTheme(args),
        success: (args: NotificationProps) => openNotificationWithTheme({ ...args, type: 'success' }),
        error: (args: NotificationProps) => openNotificationWithTheme({ ...args, type: 'error' }),
        info: (args: NotificationProps) => openNotificationWithTheme({ ...args, type: 'info' }),
        warning: (args: NotificationProps) => openNotificationWithTheme({ ...args, type: 'warning' }),
    };
};

export default useNotification;